import React from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../../firebase";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

function ExcelDownload() {

  const handleDownloadExcel = async () => {
    try {
      // 🔥 Fetch data from Firestore
      const querySnapshot = await getDocs(collection(db, "users"));

      // 📊 Convert Firestore data → JSON
      const data = querySnapshot.docs.map((doc) => {
        const d = doc.data();
        return {
          Name: d.name || "",
          Mobile: d.mobile || "",
          City: d.city || "",
          Date: d.createdAt
            ? new Date(d.createdAt.seconds * 1000).toLocaleString()
            : "",
        };
      });

      // 📄 JSON → Worksheet
      const worksheet = XLSX.utils.json_to_sheet(data);

      // 📘 Create Workbook
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Users");

      // ⚙️ Generate Excel file
      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });

      // 📥 Download file
      const blob = new Blob([excelBuffer], {
        type:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      saveAs(blob, "UserData.xlsx");

    } catch (error) {
      console.error("Excel Download Error:", error);
      alert("Failed to download Excel");
    }
  };

  return (
    <div>
      <button className="excel" onClick={handleDownloadExcel}>
        Download Excel
      </button>
    </div>
  );
}

export default ExcelDownload;